import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-storecostoptimizegroup",
  "use": "icon-soc-m-storecostoptimizegroup-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-storecostoptimizegroup\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"540\" cy=\"180\" r=\"28\" /><path d=\"M192 800h640v64H192z\" /><path d=\"M256 480h96v320H256zM416 352h96v448H416zM576 224h96v576H576zM736 416h96v384h-96z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-storecostoptimizegroup.svg
// module id = 3Zqm
// module chunks = 492